export default "__VITE_ASSET__BRnZ30Zm__"